var _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCloudArrowDown = function SvgCloudArrowDown(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 175,
    viewBox: "0 0 227 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.555 122.784H159.426C158.525 122.818 157.623 122.818 156.721 122.784H59.4121C59.3948 122.784 59.3774 122.784 59.3602 122.783C59.2939 122.784 59.2276 122.784 59.1613 122.784C45.2651 122.784 34 111.131 34 96.7554C34 82.38 45.2651 70.7265 59.1613 70.7265C60.5847 70.7265 61.9806 70.8488 63.3395 71.0837C65.858 47.9801 85.4323 30 109.206 30C126.268 30 141.166 39.2603 149.15 53.029C160.78 50.1946 173.609 53.3522 182.74 62.4836C196.614 76.3573 196.698 98.767 182.928 112.537C176.51 118.955 168.216 122.363 159.783 122.769C159.708 122.779 159.632 122.784 159.555 122.784Z",
    fill: "url(#paint0_linear_264_50877)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M182.74 62.4836C168.867 48.61 146.457 48.526 132.687 62.296C118.917 76.0661 119.001 98.4758 132.875 112.349C146.748 126.223 169.158 126.307 182.928 112.537C196.698 98.767 196.614 76.3573 182.74 62.4836Z",
    fill: "url(#paint1_linear_264_50877)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115 96C115 94.8954 114.105 94 113 94C111.895 94 111 94.8954 111 96L115 96ZM111.586 154.414C112.367 155.195 113.633 155.195 114.414 154.414L127.142 141.686C127.923 140.905 127.923 139.639 127.142 138.858C126.361 138.077 125.095 138.077 124.314 138.858L113 150.172L101.686 138.858C100.905 138.077 99.6389 138.077 98.8579 138.858C98.0768 139.639 98.0768 140.905 98.8579 141.686L111.586 154.414ZM111 96L111 153L115 153L115 96L111 96Z",
    fill: "url(#paint2_linear_264_50877)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_264_50877",
    x1: 113.036,
    y1: 42.4936,
    x2: 114.582,
    y2: 122.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3F2FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_264_50877",
    x1: 150.262,
    y1: 52.5063,
    x2: 150.407,
    y2: 72.4607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98C4FD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_264_50877",
    x1: 111.5,
    y1: 96,
    x2: 113.801,
    y2: 145.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EC5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BADEFC"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCloudArrowDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "cloud-arrow-down.1481ea20fd962e56d64bfe8e8962206e.svg";